import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import 'react-input-range/lib/css/index.css';
import classNames from 'classnames';
import './MediaPreviewModal.scss';
import Overlay from '../../../../_atomic/Overlay/Overlay';
import RoundButton from '../../../../_atomic/RoundButton/RoundButton';
import ImageButton from '../../../../_atomic/ImageButton/ImageButton';
import { MEDIA_TYPES } from '../../../../../utils/constants';
import { formatDuration } from '../../../../../utils/helpers';

const playIcon = require('./assets/play-icon.png');
const pauseIcon = require('./assets/pause-icon.png');
const muteIcon = require('./assets/mute.png');
const speakerIcon = require('./assets/speaker.png');
const closeIcon = require('./assets/close-icon.png');
const downloadIcon = require('./assets/download-icon.png');

const imagePreloader = require('./assets/preloader.svg');

const maxDimensions = {
  width: 800,
  height: 596,
};
class MediaPreviewModal extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    fileLink: PropTypes.string.isRequired,
    requestClose: PropTypes.func.isRequired,
    dimension: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }).isRequired,
    allowDownload: PropTypes.bool,
  };
  static defaultProps = {
    allowDownload: false,
  }

  state = {
    type: MEDIA_TYPES.IMAGE,
    links: {
      imageLink: '',
      videoLink: '',
    },
    imageDimensions: {
      width: 0,
      height: 0,
    },
    volume: 0.8,
    played: 0,
    duration: 0,
    seeking: false,
    playing: true,
    muted: false,
    imageLoaded: false,
    videoLoaded: false,
  };

  componentDidUpdate(prevProps) {
    const { fileLink, dimension } = this.props;
    const links = { ...this.state.links };
    let { imageLoaded, videoLoaded } = this.state;
    let imageDimensions = { ...this.state.imageDimensions };

    if (prevProps.fileLink !== fileLink) {
      const type = this.getFileType(fileLink);
      if (fileLink) {
        if (type === MEDIA_TYPES.IMAGE) {
          links.imageLink = fileLink;
          links.videoLink = '';
          this.imageStatus(fileLink);
        } else {
          links.imageLink = '';
          links.videoLink = fileLink;
        }

        if (JSON.stringify(dimension) !== JSON.stringify(prevProps.dimension)
        && dimension.width !== 0) {
          imageDimensions = this.getImageDimensions(dimension);
        }
      } else {
        links.imageLink = '';
        links.videoLink = '';
        imageDimensions = {
          width: 0,
          height: 0,
        };
        imageLoaded = false;
        videoLoaded = false;
      }

      this.setState(() => ({
        type,
        links,
        imageDimensions,
        played: 0,
        imageLoaded,
        videoLoaded,
      }));
    }
  }


  onSeekMouseDown = () => {
    this.setState({ seeking: true });
  };
  onSeekChange = (e) => {
    this.setState({ played: parseFloat(e.target.value) });
  };
  onSeekMouseUp = (e) => {
    this.setState({ seeking: false });
    this.player.seekTo(parseFloat(e.target.value));
  };

  onProgress = (state) => {
    if (!this.state.seeking) {
      this.setState(state);
    }
  };
  onDuration = (duration) => {
    this.setState({ duration });
  };
  onEnded = () => {
    this.setState({ playing: false });
  }
  onReady = () => {
    this.setState({ videoLoaded: true });
  }

  setVolume = (e) => {
    this.setState({ volume: parseFloat(e.target.value) });
  };

  getImageDimensions = (dimensions) => {
    const result = { ...dimensions };
    const { width, height } = maxDimensions;
    if (dimensions.width > width || dimensions.height > height) {
      const widthRatio = dimensions.width / width;
      const heightRatio = dimensions.height / height;
      const ratio = widthRatio > heightRatio ? widthRatio : heightRatio;


      result.height = dimensions.height / ratio;
      result.width = dimensions.width / ratio;
    }
    return result;
  }
  getFileType = (fileLink) => {
    let result = MEDIA_TYPES.IMAGE;
    const test = fileLink.match(/mp[eg]?4/gi);
    if (test && test.length) {
      result = MEDIA_TYPES.VIDEO;
    }
    return result;
  };

  imageStatus = (link) => {
    const image = new Image();
    image.onload = () => {
      this.setState(() => ({
        imageLoaded: true,
      }));
    };
    image.src = link;
  }

  playerRef = (player) => {
    this.player = player;
  };
  playPause = () => {
    this.setState({ playing: !this.state.playing });
  };
  toggleMuted = () => {
    this.setState({ muted: !this.state.muted });
  };
  renderImagePreview = (link) => {
    const { imageDimensions: { width, height }, imageLoaded } = this.state;
    return (
      <div
        style={{ backgroundImage: `url(${link}`, width: `${width}px`, height: `${height}px` }}
        className="media-modal-preview"
      > {!imageLoaded ? <div className="media-preloader"> <img src={imagePreloader} alt="img-preloader" /> </div> : null }
      </div>
    );
  }


  renderVideoPreview = (link) => {
    const {
      played, playing, duration, volume, muted, videoLoaded,
    } = this.state;
    const playButtonClasses = classNames({
      playing,
    });
    const muteButtonClasses = classNames({
      'mute-button': true,
      muted,
    });

    return (
      <div className="video-modal-preview">
        <div className="video-wrapper">
          {!videoLoaded ? <div className="media-preloader"> <img src={imagePreloader} alt="img-preloader" /> </div> : null }
          <div className="video-overlay" />

          <ReactPlayer
            ref={this.playerRef}
            playing={playing}
            onProgress={this.onProgress}
            onDuration={this.onDuration}
            onEnded={this.onEnded}
            onReady={this.onReady}
            url={link}
            volume={volume}
            muted={muted}
            width="100%"
            height="100%"
          />
          <div className="video-controls">
            <div className="left-control-wrapper">
              <RoundButton
                className={playButtonClasses}
                onClick={this.playPause}
                radius={28}
              >
                {playing ? (
                  <img src={pauseIcon} alt="pause" />
                ) : (
                  <img src={playIcon} alt="play" />
                )}
              </RoundButton>
            </div>
            <div className="duration-wrapper">
              <div className="current-duration-wrapper duration-time">
                <span> {formatDuration(duration * played)} </span>
              </div>
              <div className="seek-wrapper">
                <input
                  type="range"
                  min={0}
                  max={1}
                  step="any"
                  value={played}
                  onMouseDown={this.onSeekMouseDown}
                  onChange={this.onSeekChange}
                  onMouseUp={this.onSeekMouseUp}
                />
              </div>
              <div className="all-duration-wrapper duration-time">
                <span>{formatDuration(duration)}</span>
              </div>
            </div>
            <div className="volume-wrapper">
              <ImageButton
                clickHandler={this.toggleMuted}
                className={muteButtonClasses}
                width={24}
                height={24}
                imgLink={muted ? muteIcon : speakerIcon}
              />
              <input
                type="range"
                value={volume}
                max={1}
                min={0}
                step="any"
                onChange={this.setVolume}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { visible, requestClose, allowDownload } = this.props;
    const { type, links } = this.state;
    const mediaOverlayClasses = classNames({
      'media-modal-overlay': true,
      'is-video': type !== MEDIA_TYPES.IMAGE,
    });

    return (
      <Overlay
        visible={visible}
        onClick={requestClose}
        className={mediaOverlayClasses}
      >
        <div className="media-modal-wrapper">
          <ImageButton clickHandler={requestClose} className="close-media-modal" imgLink={closeIcon} width={40} height={40} />
          {type === MEDIA_TYPES.IMAGE
            ? this.renderImagePreview(links.imageLink)
            : this.renderVideoPreview(links.videoLink)}
          {/* eslint-disable */}
          {allowDownload &&
            
            <a download target="_blank" href={type === MEDIA_TYPES.IMAGE ? links.imageLink : links.videoLink} >
              <ImageButton clickHandler={() => {}} className="download-media-modal" imgLink={downloadIcon} width={60} height={60} />
            </a> }
        </div>
      </Overlay>
    );
  }
}

export default MediaPreviewModal;



// WEBPACK FOOTER //
// ./src/components/_molecules/MediaLibraryFull/components/MediaPreviewModal/MediaPreviewModal.js